import { type RPPDomain } from '@retailer-platform/dashboard/core'
import { NavEntryPoint, NavEntryPointV3 } from '@retailer-platform/dashboard/routing'
import { customersRouter } from './routing/customersRouter'
import { type DomainMessages } from './utils/domain/intl'
import { routes } from './routing/routes'
import EN_US from './translations/en-US.json'
import { type DomainAccessControlConfig } from './utils/domain/accessControl'
import {
  customersAccessControl,
  customersPrivacyRequestsAccessControl,
} from './access-control/customersAccess.configuration'
import { Permission } from './access-control/permissions'

const definition: RPPDomain<typeof routes, DomainMessages, DomainAccessControlConfig> = {
  id: 'customers',
  totem: {
    // The default IPP tool of all routes in this domain - should match the Navigation Entry in IPP UI.
    // Individual routes can override this by specifying a `tool` prop on their DomainRoute component
    tool: 'customers-dashboard-tool',
  },
  routes,
  translations: { EN_US },
  lazyTranslations: {
    ES_ES: () => import('./translations/es-ES.json'),
    FR_FR: () => import('./translations/fr-FR.json'),
  },
  routers: {
    scoped: [customersRouter],
  },
  navigationEntries: [
    {
      attachToV2: NavEntryPoint.OperationsCustomerSupport,
      attachToV3: NavEntryPointV3.CustomersAndOrders,
      subNavItems: [
        {
          type: 'item',
          llmDescription: 'Search and view customer information and details',
          labelId: 'customersDomain.search.pageTitle',
          labelIdV3: 'customersDomain.search.pageTitle.v3',
          route: 'customers-search',
          subRoutes: ['customers-customer-details'],
          position: 1,
          positionNavV2: 5,
          positionNavV3: 0,
          accessControl: customersAccessControl,
          inToolPermissions: [
            {
              slug: Permission.CustomersAppeasementsModifyAccess,
              permissionLabelId:
                'permissionAccordion.permissions.' + Permission.CustomersAppeasementsModifyAccess,
            },
            {
              slug: Permission.CustomersAppeasementsView,
              permissionLabelId:
                'permissionAccordion.permissions.' + Permission.CustomersAppeasementsView,
            },
          ],
        },
        {
          type: 'item',
          llmDescription: 'Manage customer privacy requests and data deletion',
          labelId: 'customersDomain.privacyRequests.pageTitle',
          labelIdV3: 'customersDomain.privacyRequests.pageTitle.v3',
          route: 'customers-privacy-requests',
          position: 2,
          positionNavV2: 6,
          positionNavV3: 1,
          accessControl: customersPrivacyRequestsAccessControl,
        },
      ],
    },
  ],
  adminNavigationEntries: [],
}

export default definition
